import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import { getBrowserLocale, flattenMessages } from '../utils/intl/index.js';

import '@getgrover/ui/lib/styles.css';
// This import forces style to be processed by weback
// and will be used by Django as well as in a SPA
import '../styles/index.scss';
import messages_de from '../translations/de.json';
import messages_en from '../translations/en.json';
import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';

(async () => {
    const node = document.getElementById('root');
    if (node) {
        const { CheckoutApp } = await import('../components/CheckoutApp');
        const messages = {
            de: flattenMessages(messages_de),
            en: flattenMessages(messages_en),
        };
        const language = getBrowserLocale();

        addLocaleData([...locale_en, ...locale_de]);

        ReactDOM.render(
            <IntlProvider locale={language} messages={messages[language]}>
                <CheckoutApp />
            </IntlProvider>,
            node
        );
    }
})();
